import {
  CaseComment,
  CaseCommentAttributes,
  CaseCommentRelationships,
} from 'dashboard/models/case-comment';
import { ApiModel } from 'lib/interfaces/api';

const createdAt = '2023-01-01T00:00:00.000Z';
const updatedAt = '2023-01-01T00:01:00.000Z';

export function createPreviewCaseComment(
  attributes?: Partial<CaseCommentAttributes>,
  relationships?: Partial<CaseCommentRelationships>,
  id?: string,
): CaseComment {
  return {
    id: id || 'cscm_123',
    type: ApiModel.CaseComment,
    attributes: {
      message: '<p>A preview message</p>',
      'created-at': createdAt,
      'updated-at': updatedAt,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'archived-at': null,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'edited-at': null,
      ...attributes,
    },
    relationships: {
      case: {
        data: {
          id: 'case_id',
          type: ApiModel.Case,
        },
      },
      commenter: {
        data: {
          id: 'user_id',
          type: ApiModel.User,
        },
      },
      commenterWorkflow: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      commenterWorkflowVersion: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      ...relationships,
    },
  };
}
